import React from "react";
import "../../css/style.css";
import picture from "../images/sumit.jpg";

const About = () => {
  return (
    <section
      className="container py-5 text-white"
      style={{ minHeight: "450px" }}
      aria-labelledby="about-title"
    >
      <div
        className="text-center mb-5"
        style={{ maxWidth: "720px", margin: "0 auto" }}
      >
        <h2
          id="about-title"
          className="heading"
          style={{ fontWeight: 800, letterSpacing: "0.05em" }}
        >
          About Me
        </h2>
        <hr style={{ color: "black" }} />
        <p
          className="text-muted"
          style={{ fontSize: "1rem", maxWidth: "600px", margin: "1rem auto 0" }}
        >
          Passionate developer committed to crafting elegant, efficient, and
          impactful digital experiences.
        </p>
      </div>

      <div
        className="d-flex flex-column flex-md-row justify-content-center align-items-start"
        style={{ gap: "3rem", maxWidth: "900px", margin: "0 auto" }}
      >
        {/* Profile image */}
        <div
          style={{
            flexShrink: 0,
            width: "300px",
            height: "auto",
            maxHeight: "400px",
            borderRadius: "12px",
            overflow: "hidden",
            boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
          }}
        >
          <img
            src={picture}
            alt="Sumit Kumar"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        </div>

        {/* Text content */}
        <div style={{ flex: 1, color: "var(--color-white)" }}>
          <p
            className="content"
            style={{
              fontSize: "1.125rem",
              lineHeight: "1.7",
              marginBottom: "1.25rem",
            }}
          >
            Hello! I'm <strong>Sumit Kumar</strong>, a dedicated front-end
            developer with a strong focus on building scalable, user-centric web
            applications. My expertise lies in creating clean, maintainable code
            that ensures both performance and accessibility.
          </p>

          <p
            className="content"
            style={{
              fontSize: "1.125rem",
              lineHeight: "1.7",
              marginBottom: "1.25rem",
            }}
          >
            I specialize in <strong>React</strong>, leveraging modern features
            like Hooks, Context API, and component-based architecture to build
            dynamic interfaces. I'm also proficient in state management tools
            such as <strong>Redux</strong> and seamless routing with{" "}
            <strong>React Router</strong>.
          </p>

          <p
            className="content"
            style={{
              fontSize: "1.125rem",
              lineHeight: "1.7",
              marginBottom: "1.25rem",
            }}
          >
            My full-stack capabilities include integrating front-end interfaces
            with <strong>REST APIs </strong> . I follow best practices in
            optimization, and performance tuning to deliver reliable and fast
            applications.
          </p>

          <p
            className="content"
            style={{
              fontSize: "1.125rem",
              lineHeight: "1.7",
              marginBottom: "1.25rem",
            }}
          >
            Beyond front-end development, I also work with{" "}
            <strong>Python and Google App Script</strong> for backend scripting, use{" "}
            <strong>DevOps</strong> tools (Jenkins) for automated deployments, and
            occasionally develop games using <strong>Unity/C#</strong>. I'm
            always learning and exploring new tools to enhance my workflow.
          </p>

          <p
            className="content"
            style={{ fontSize: "1.125rem", lineHeight: "1.7" }}
          >
            When I'm not coding, you'll find me exploring new technologies,
            gaming, or enjoying the outdoors — all of which inspire creativity
            in my work.
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
